export default defineNuxtRouteMiddleware((to) => {
	const config = useRuntimeConfig();

	if (config.public.maintenanceMode && to.path !== '/maintenance') {
		return navigateTo('/maintenance');
	}
});
